module.exports = __webpack_public_path__ + "static/media/75a-the-founding-of-prc-04.9319bf0e.png";